import { ArrowDownCircleIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { Button } from "V2.0/common/button";
import { ExtractionsDownloader } from "V2.0/HomePages/Downloads/Extractions";

function ExtractionDownload(props) {
  const { projectId, assistantId, assistantType } = props;
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        color="white"
        onClick={() => setOpen(true)}
      >
        <ArrowDownCircleIcon /> Download
      </Button>
      {open && (
        <ExtractionsDownloader
          isOpen={open}
          onClose={() => setOpen(false)}
          projectId={projectId}
          assistantId={assistantId}
          assistantType={assistantType}
        />
      )}
    </>
  );
}

export { ExtractionDownload };
